import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SignInContainer from "./SignInContainer";
import ProtectedRoute from "../shared/ProtectedRoute";

const SignInRoute: React.ComponentType<any> = withRouter(
  connect(({ config, auth: { isAuthenticated } }) => {
    return {
      component: SignInContainer,
      restProps: {
        config,
        isAuthenticated,
      },
      // Always accessible (public route)
      isAllowedRoute: true,
      redirectTo: "/home",
    };
  })(ProtectedRoute)
);

export default SignInRoute;
